'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Modal from 'react-modal';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy } from 'com-gyf-webcore-servicehub';
import { GenericModal, GenericAlert, GenericBreadcrumb, GenericSimpleButton, GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import ClienteTitle from '../../../Common/Components/ClienteTitle.jsx';
import Table from './Table.jsx';
import Subtitulo from './Subtitulo.jsx';
import InputComplete from './InputComplete.jsx';
import Elementos from './Elementos.jsx';
import Footer from './Footer.jsx';
import DistribucionLimites from '../../DistribucionLimites/components/Container.jsx';
import { createForm } from 'rc-form';

/**
 * 
 * @param {any} props
 */

class NuevaSolicitudTarjeta extends Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this.props.resetStateSolicitudTarjeta();
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
    }

    render() {

        if (this.props.data) {

            if (this.props.data.redirectToNuevaSolicitudConfirmacion == true)
                return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_CONFIRMACION")} push />;

            if (this.props.data.redirectToVistaCliente == true)
                return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_VISTA_CLIENTE")} push />;

            if (this.props.data.dataFetched == false) {
                return <div className="loading"> Loading &#8230;</div>;
            }

            let permisos = this.props.data.permisos;
            if (permisos) {

                if (permisos.components.Pantalla.Active == true) {
                    let genericAlert = null;
                    let genericAlertDate = null;
                    if (this.props.data.showError) {
                        $(window).scrollTop(0);
                        genericAlert = <GenericAlert message="Por favor, recuerde que debe agregar al menos una Tarjeta ya que es parte de la solicitud." type="danger" />
                    }

                    if (this.props.data.showErrorData) {
                        $(window).scrollTop(0);
                        genericAlertDate = <GenericAlert message="Faltan completar datos." type="danger" />
                    }

                    let distributionModal = null;
                    let disabledDisLimitesProp = { disabled: "disabled" };

                    if (permisos.components.BotonDistribuirLimites.Locked == false) {
                        delete disabledDisLimitesProp.disabled;
                    }

                    return (
                        <div className="container-fluid">
                            <ClienteTitle
                                titulo={(this.props.tarjetas.esModificacion == true ? "Solicitud para " : "Nueva solicitud para ") + this.props.data.cliente.description}
                                cliente={this.props.data.cliente}
                                empresas={this.props.data.empresas}
                                novedadesEmpresas={this.props.tarjetas.novedadesEmpresas} />
                            {<GenericBreadcrumb className="breadcrumb"
                                currentScreen={this.props.currentScreen}
                                menu={this.breadcrumbGenerator()}
                                product={this.props.product}
                                module={this.props.module} />
                            }
                            {(permisos.components.BotonDistribuirLimites.Active == true) &&
                                <GenericSimpleButton text="Distribuir límites"
                                    buttonClass="btn btn-secondary top-separator-xs bottom-separator-xs"
                                    onClick={this.props.openModalDistribucionLimites} {...disabledDisLimitesProp} />}
                            {genericAlert}
                            {genericAlertDate}
                            <Subtitulo titulo="Tarjetas de la cuenta"
                                subtitleClass="bottom-separator separator-grey-light" />
                            <Table data={this.props.data}
                                permisos={permisos}
                                editDate={this.props.editDate}
                                deleteDate={this.props.deleteDate} />
                            <div className="container-fluid container-fluid-bordered top-separator-xs">
                                <Subtitulo titulo={"Nueva Tarjeta: "}
                                    value={this.props.data.estado == "Aplicar Cambios" ? this.props.data.tarjetaAeditar.Ordenamiento : this.props.data.tarjetasFiltradas.length + 1}
                                    subtitleClass="" />
                                <InputComplete
                                    data={this.props.data}
                                    permisos={permisos}
                                    getHeadline={this.props.getHeadline}
                                    validateAlphaOnly={this.props.validateAlphaOnly}
                                    getLimit={this.props.getLimit}
                                    getDenomination={this.props.getDenomination}
                                    countCard={this.props.countCard}
                                    openDays={this.props.openDays}
                                    getDays={this.props.getDays}
                                    changeToSelectCard={this.props.changeToSelectCard}
                                    getKind={this.props.getKind}
                                    getDenomination={this.props.getDenomination}
                                    validateAddCard={this.props.validateAddCard}
                                    form={this.props.form}
                                    seleccionarCodigoDistribucion={this.props.seleccionarCodigoDistribucion}
                                />
                            </div>
                            <Footer data={this.props.data}
                                permisos={permisos}
                                routeToNuevaSolicitudConfirmacion={this.props.routeToNuevaSolicitudConfirmacion}
                                guardarSolicitudBorrador={this.props.guardarSolicitudBorrador} />

                            {
                                //Modal de límites...
                                <div className="col-md-12">
                                    <Modal
                                        isOpen={this.props.data.modalVisibleLimites}
                                        contentLabel="Modal"
                                        className={{ base: 'modal-react-example-css' }}>
                                        <DistribucionLimites
                                            data={this.props.data}
                                            globalState={this.props.globalState}
                                            guardaDatos={false} //<----- indica si la info se guarda en la BBDD...
                                            getDatosFromDB={false} //<----- Se carga con datos de la BBDD y no del store generico al ser true...
                                            currentScope={this.props.currentScope}
                                            functions={permisos}
                                            cerrarModal={this.props.closeModalDistribucionLimites}
                                            actualizarEstadoPantallaInvocadora={this.props.actualizarLimites} //<----- Ejecuta la action que actualiza el estado de la pantalla que lo invoca...
                                        />
                                    </Modal>
                                </div>
                            }

                            <GenericModal type={"DISCARD_CHANGES_CANCEL"}
                                className="modal fade-out"
                                onClick={this.cancelRequest}
                                id={"discardChangesModal"}
                                header={"Descartar cambios"}
                                body={"Usted tiene cambios sin guardar ¿Quiere descartarlos y volver a la pantalla inicial?"} />
                            <GenericModal type={"OK_OTHER"}
                                className="modal fade-out"
                                id={"error"}
                                header={"La transacción no puede ser procesada"}
                                body={"Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " + this.props.data.sagaId}
                                onClick={this.closeModal} />
                            <GenericModal type={"OK_OTHER"}
                                className="modal fade-out"
                                id={"completada"}
                                body={"La transacción ha sido creada exitosamente"}
                                onClick={this.closeModal} />
                            <GenericModal type={"OK_OTHER"}
                                className="modal fade-out"
                                id={"completadaConDependencias"}
                                header={"La transacción esta pendiente a ser procesada"}
                                body={"Disculpe, hay datos en la transacción que dependen de procesos que todavían no fueron finalizados, por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los que dependen esta transacción hayan finalizado correctamente será avisado y la transacción avanzará automáticamente por su circuito normal."}
                                onClick={this.closeModal} />
                        </div>);
                }
                else {
                    if (permisos.components.Pantalla.Active == false) {
                        let values = {
                            message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                            linkMessage: "Volver a mi pagina de inicio"
                        };

                        return <GenericErrorScreen data={values} />;
                    }
                }
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    breadcrumbGenerator() {
        let nuevaSolicitudMap = [];
        nuevaSolicitudMap.push({
            descripcion: this.props.tarjetas.administradora.Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_ADMINISTRADORA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.tarjetas.tipoEmpresa.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_TIPO_EMPRESA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.tarjetas.empresas.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_EMPRESA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.tarjetas.cuentas.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_CUENTA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({ descripcion: "Tarjetas", ruta: "", activo: true, normal: true });
        nuevaSolicitudMap.push({ descripcion: "Confirmacion", ruta: "", activo: false, normal: true });

        return nuevaSolicitudMap;
    }

    closeModal() {
        $('.modal').modal('hide');
    }

    //goToLimits () {
    //    DistribucionLimitesActions.changeLimit(2);
    //    NewRequestCreateCardActions.routeToLimits();
    //}
}

export default createForm()(NuevaSolicitudTarjeta);